import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { object, string } from 'yup';

import { formMessages } from '@/messages/forms';

export type ServicePricesSearchSchema = InferType<
  ReturnType<typeof servicePricesSearchSchema>
>;

export const servicePricesSearchSchema = (
  formatMessage: IntlShape['formatMessage'],
) => {
  const requiredMsg = formatMessage(formMessages.requiredField);

  const schema = object({
    number: string().required(requiredMsg).default(''),
  });
  return schema;
};
